<template>
  <div class="modal" tabindex="-1" role="dialog" id="deleteModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header bg-danger text-white">
          <h5 class="modal-title">{{ title }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>{{ message }}</p>
          <div class="bg-light p-3" v-html="detail" v-if="detail && detail !== ''"></div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">取消</button>
          <button type="button" class="btn btn-danger" @click="checkDelete">確認刪除</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['message', 'color', 'detail'],
  data() {
    return {
      show: false,
      body: '',
      title: '你確定要刪除？',
      classColor: 'danger',
    };
  },
  created() {
    if (this.message) {
      this.flash(this.message);
    }
    window.events.$on('flash', (message, color) => this.flash(message, color));
  },
  methods: {
    flash(message, color) {
      this.show = true;
      this.body = message;
      this.classColor = color;

      setTimeout(() => {
        this.hide();
      }, 8000);
    },
    hide() {
      this.show = false;
    },
    checkDelete() {
      this.$emit('deleteSure', true);
      $('#deleteModal').modal('hide');
    },
  },
};
</script>

<style scoped>
.modal {
  z-index: 1061;
}
</style>
